<template>
  <div class="custom-card-title">
    <!-- ✅ 本页名称 -->
    <span class="breadcrumb-page-name">
      {{ pageName }}&nbsp;|&nbsp;
    </span>

    <!-- ✅ 面包屑主体 -->
    <span
      v-for="(item, index) in list"
      :key="index"
      class="breadcrumb-item"
      :class="{ 'current': item.disabled }"
      @click="!item.disabled && handleClick(item)"
    >
      <el-tooltip
        v-if="item.tooltip"
        effect="dark"
        placement="top"
        :content="item.tooltip"
      >
        <span class="breadcrumb-current-text">
           {{ item.label }}
        </span>
      </el-tooltip>
      <span v-else>
        {{ item.label }}
      </span>

      <span
        v-if="index !== list.length - 1"
        class="breadcrumb-separator"
      >/
      </span>
    </span>

    <!-- ✅ 右侧按钮 -->
    <div class="title-right-btn">
      <slot name="right-btn"/>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AppBreadcrumb',
  props: {
    list: {
      type: Array,
      required: true
    },
    pageName: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick(item) {
      if (item.to) {
        this.$router.push(item.to);
        this.$EventBus.$emit('currentPath', item.to);
      }
    }
  }
};
</script>

<style scoped lang="scss">
    .custom-card-title {
    position: relative;
    width: 100%;
    min-width: 390px;
    height: 100%;
    font-size: 20px;
    // font-size: 1.3rem;
    color: rgba(37, 100, 207, 0.8);
    display: flex;
    align-items: center;
    flex-wrap: wrap;              /* ✅ 和手机端一样：内容显示不完时自动换行 */
    white-space: normal;          /* ✅ 取消强制单行（原来 nowrap 会让超长内容被裁） */
    row-gap: 4px;                 /* ✅ 换行后两行之间的间距 */
    padding-left: 20px;
    box-sizing: border-box;
    overflow: visible;            /* ✅ 取消裁切 —— 原来 overflow:hidden 会把换到第二行的按钮整个裁掉，这正是"按钮被遮挡"的根因 */
    overflow-wrap: break-word;    /* ✅ 防止超长单词/URL 撑破布局 */
    /* text-overflow: ellipsis 去掉 —— 已经不是单行裁切 */

    .title-right-btn {
        margin-left: auto;        /* ✅ 推到当前行最右；位置不够时 flex-wrap 会把它换到下一行，仍然右对齐 */
        padding-right: 20px;
        flex-shrink: 0;           /* ✅ 按钮永远不被压缩、永远完整可见 */
    }
    }
    .breadcrumb-page-name {
      color: #4D4F53;        /* ✅ gray（Element UI 标准灰） */
      font-weight: normal;   /* ✅ 不抢主标题 */
      margin-right: 6px;     /* ✅ 和后面面包屑拉开距离 */
      user-select: none;    /* ✅ 不让选中 */
    }
    

    .breadcrumb-fixed {
    color: #2564CF;
    font-weight: bold;
    margin-right: 4px;
    font-size: 20px;
    }

    .breadcrumb-item {
    color: rgba(37, 100, 207, 0.8);
    cursor: pointer;
    font-size: 20px;

    &.current {
        color: #2564CF;
        cursor: default;
    }
    }

    .breadcrumb-separator {
    margin: 0 6px; 
    color: #4D4F53;
    font-size: 20px;
    }

    .breadcrumb-current-text {
    display: inline-block;
    max-width: 30ch;  /* ✅ 20 个字符宽度 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    }

    /* ======================
    手机端
    ====================== */
    @media (max-width: 768px) {
    .custom-card-title {
        white-space: normal !important;
        flex-wrap: wrap;
        font-size: 12px !important;
        padding-left: 10px !important;
        min-width: unset !important;
    }

    .breadcrumb-fixed,
    .breadcrumb-item,
    .breadcrumb-separator {
        font-size: 12px !important;
    }

    .breadcrumb-current-text {
        max-width: 18ch;
    }

      /* ======================
    面包屑整体字体缩小
    ====================== */
  .custom-card-title {
    /* ✅ 允许换行 */
    white-space: normal !important;
    word-break: break-word;

    /* ✅ 取消强制单行 */
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    font-size: 12px !important;
    padding-left: 10px !important;
    min-width: unset !important;
  }

  .breadcrumb-fixed {
    font-size: 12px !important;
  }

  .breadcrumb-item {
    font-size: 12px !important;
  }

  .breadcrumb-separator {
    font-size: 12px !important;
  }

  .breadcrumb-item.current {
    font-size: 12px !important;
  }

  /* ✅ 售后按钮同步缩小 */
  .title-right-btn .el-button {
    font-size: 12px !important;
    padding: 4px 8px !important;
  }
  // --------------------面包屑格式结束--------------------------------
}
</style>

